import styles from './Divider.module.scss';
import { ReactSVG } from 'react-svg';
import { useEffect, useRef, useState } from 'react';
import invariant from 'tiny-invariant';
import { dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { canMove } from '../../utils/dragAndDrop';
import { dataResources } from '@portal-internet/core';
import { useRedl } from 'hooks/useRedl';

const { basePath } = dataResources;

export default function DividerComponent({ blocIdx, size }) {
    const { setShowRightSidePanel } = useRedl();
    const ref = useRef(null);
    const [isDraggedOver, setIsDraggedOver] = useState(false);

    useEffect(() => {
        const el = ref.current;
        invariant(el);

        return dropTargetForElements({
            element: el,
            getData: () => ({ blocIdx }),
            onDragEnter: () => setIsDraggedOver(true),
            onDragLeave: () => setIsDraggedOver(false),
            onDrop: () => setIsDraggedOver(false),
            canDrop: ({ source }) => canMove(source, blocIdx)
        });
    }, [blocIdx]);

    return (
        <div ref={ref} className={`${styles.redlDivider} ${styles[`redl-divider-${size}`]}`}>
            {isDraggedOver ?
                <div className={styles.redlDividerDrag}>
                    <span className={styles.redlDividerDragCircle}></span>
                    <span className={styles.redlDividerDragLine}></span>
                </div> :
                <button className={styles.redlDividerButton} data-testid={`REDL-add-button-${blocIdx}`}
                        onClick={() => setShowRightSidePanel({ size: 'md', action: 'add', blocIdx })}>
                    <div className={styles.redlDividerInnerIcon}>
                        <span className={styles.redlDividerIcon}>
                            <ReactSVG src={basePath + '/_resources/REDL/icons/plus.svg?v=JIT_ENV_RESOURCES_VERSION'} />
                        </span>
                    </div>
                    <div className={styles.redlDividerInnerDot}>
                        <span className={styles.redlDividerDot}></span>
                    </div>
                </button>}
        </div>
    );
}